import utilsProvider from '../../../components/providers/utils.provider';

import loginService from '../login.service';

import repository from '../../repositories/crm/crm.voice.call.repository';

const generateToken = (sellerId) =>
    repository
        .generateToken(sellerId)
        .then(res => res.data || {});

const withoutEmptyParams = (params) =>
    Object.fromEntries(Object.entries(params).filter(([, value]) => value !== undefined && value !== null));

const startCall = async (device, phoneNumber, opportunityId, contactId, customerId) => {

    const params = withoutEmptyParams({
        To: '+55' + utilsProvider.getFormatCellphone(phoneNumber),
        opportunityId,
        contactId,
        customerId,
        callerUserId: loginService.getUserAuthentication()?.id
    });

    return device.connect({ params });
}

const update = async (voiceCallId, data) =>
    repository.update(voiceCallId, data);

const findByCustomerId = async (customerId, pagination) =>
    repository
        .findByCustomerId(customerId, pagination)
        .then(res => res.data || { results: [], total: 0 });

const findByProviderCallId = async (providerCallId) =>
    repository
        .findByProviderCallId(providerCallId)
        .then(res => res.data || {});

const findDiagnosticsByProviderCallId = async (providerCallId) =>
    repository
        .findDiagnosticsByProviderCallId(providerCallId)
        .then(res => res.data || {});

const saveQualityTelemetryByProviderCallId = async (providerCallId, data) =>
    repository
        .saveQualityTelemetryByProviderCallId(providerCallId, data)
        .then(res => res.data || {});

export default {
    generateToken,
    startCall,
    update,
    findByCustomerId,
    findByProviderCallId,
    findDiagnosticsByProviderCallId,
    saveQualityTelemetryByProviderCallId
}
